import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/devtools/billing-sim")({
  component: lazyRouteComponent(() => import("./+BillingSim")),
  head: () => ({ meta: seo({ title: "Billing Sim" }) }),
});
